'use strict';

var _ = require('lodash');
var TrendComputingService = function TrendComputingService() {
  function getTrendClass(currValue, lyValue, customTrendUp, customTrendDown) {
    if (!currValue && !lyValue || currValue === lyValue || _.isNil(currValue) || _.isNil(lyValue)) {
      return '';
    }
    if (currValue > lyValue) {
      return customTrendUp || 'trend-up-double';
    } else if (currValue < lyValue) {
      return customTrendDown || 'trend-down-double';
    }
  }
  return {
    getTrendClass: getTrendClass
  };
};
TrendComputingService.$inject = [];
module.exports = TrendComputingService;